import { Component, OnInit, input, output } from '@angular/core';

import { Subject } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput } from '@camelot/form-model';
import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import {
  ButtonComponent,
  LayoutSideComponent,
  LayoutSideContentComponent,
  LayoutSideCtaComponent,
  LinkComponent,
} from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationCore } from '../../../translation.service';

@Component({
  selector: 'cam-filter-container',
  templateUrl: './filter-container.component.html',
  styleUrls: ['./filter-container.component.scss'],
  imports: [
    ButtonComponent,
    FontIconComponent,
    FormComponent,
    LayoutSideComponent,
    LayoutSideContentComponent,
    LayoutSideCtaComponent,
    LinkComponent,
    TranslatePipe,
  ],
})
export class FilterContainerComponent extends CamBaseComponent implements OnInit {
  form = input<CamAbstractInput[]>([]);

  filtersSelected = output<any>();

  public isFilterOpen = false;

  public askValidation$ = new Subject<null>();
  public askClear$ = new Subject<null>();

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  ngOnInit(): void {
    if (this.askClear$) {
      this._registerSubscription(this.askClear$.subscribe(_ => this.clear()));
    }
  }

  public apply(data: any) {
    this.filtersSelected.emit(data);
  }

  public clear() {
    this.filtersSelected.emit(null);
  }

  public validate() {
    this.askValidation$.next(null);
  }
}
